import { Component, Input } from '@angular/core';
import { CustomDxfViewer } from '../shared/dxf/custom-dxf-viewer';
import { DxfViewerLoadParams } from 'dxf-viewer';
import { Article } from '../shared/models/article.interface';

@Component({
    selector: 'app-dxf-viewer',
    templateUrl: './dxf-viewer.component.html',
    styleUrls: ['./dxf-viewer.component.scss'],
    standalone: false
})
export class DxfViewerComponent {
  imageUrl: string | undefined;

  @Input() articleName!: string;
  @Input() articleDxf!: Article["DxfStoragePath"];
  errorMessage: string = '';
  hasImage: boolean = false;

  constructor(
    private dxfViewer: CustomDxfViewer
  ) {
  }

  ngOnInit(): void {
    if (this.articleDxf) {
      this.convertDxfToJpg(this.articleDxf);
      this.hasImage = true;
    } else {
      this.errorMessage = 'No DXF file found for this article.';
      this.hasImage = false;
    }
  }

  /**
   * Converts a DXF file to a JPG file.
    * @param dxfFiles The DXF file to convert.
    * @returns A promise that resolves when the conversion is complete.
    * @private
    */
  private async convertDxfToJpg(dxfUrlInput: string) {
    const dxfUrl = dxfUrlInput;

    const dxfViewerLoadParams: DxfViewerLoadParams = {
      url: dxfUrl,
      fonts: null, // Replace with actual fonts if needed
      progressCbk: null, // Replace with actual callback if needed
      workerFactory: null // Replace with actual worker factory if needed
    };

    await this.dxfViewer.Load(dxfViewerLoadParams);
    const jpgData = this.dxfViewer.toDataURL('image/jpeg', 0.92);

    this.imageUrl = jpgData;
  }
}
